import { types } from 'mobx-state-tree';

import { CheckoutPageModuleType } from '../../types/checkout/CheckoutPageModule';
import { OrderAlertType } from '../../types/order/OrderAlert';

const OrderAlert = types.model('OrderAlert', {
  is_static: types.boolean,
  message: types.string,
  section: types.maybeNull(CheckoutPageModuleType),
  type: OrderAlertType,
});

export default OrderAlert;
